import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-sum-of-reward',
  templateUrl: './sum-of-reward.component.html',
  styleUrls: ['./sum-of-reward.component.css']
})
export class SumOfRewardComponent implements OnInit {

  @Input() userSumReward: any;
  math = Math;

  total:number = 0;
  category_id: number;
  Prize: any[] = [];

  constructor() { }

  ngOnInit() {
  }
//   this.userSumReward.sales[0].commission.forEach(function(element) {
//     if(element.premium_name === "TOTAL"){
//       this.total = element.premium_amount;
//     }
// });
  ngOnChanges(){
    if(this.userSumReward.sales != undefined){
      this.category_id = this.userSumReward.category_id;
      for (let element of this.userSumReward.sales[0].commission) { 
        if(element.comission_name === "TOTAL"){
          this.total = element.comission_sum;
        }
        else{
          this.Prize.push(element);
        }
      }
    }
}

}
